import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../services/firebase';
import { useAuth } from '../contexts/AuthContext';
import styles from './LoginPage.module.css';
import GoogleSignInButton from '../components/auth/GoogleSignInButton';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  useEffect(() => { if (isLoggedIn) navigate('/'); }, [isLoggedIn, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!email || !password) { setError('Lütfen e‑posta ve şifre girin.'); return; }
    try {
      setLoading(true);
      await loginUser(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Giriş yapılırken hata oluştu.');
      console.error(err);
    } finally { setLoading(false); }
  };

  const handleGoogleSuccess = () => navigate('/');
  const handleGoogleError = (error: Error) => setError(error.message || 'Google ile giriş hatası.');

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginShell}>
        <div className={styles.headArea}>
          <img src="/logo.png" alt="vagonla" className={styles.brandLogo} />
          <h1 className={styles.pageTitle}>Giriş Yap</h1>
          <p className={styles.pageSubtitle}>Hesabına eriş, hatları yönet, favorilerini senkronize et.</p>
        </div>
        <div className={styles.formCardGlass}>
          {error && <div className={styles.errorBox}>{error}</div>}
          <form onSubmit={handleSubmit} className={styles.formLayout}>
            <div className={styles.fieldGroup}>
              <label htmlFor="email" className={styles.fieldLabel}>E‑posta</label>
              <input
                type="email"
                id="email"
                className={styles.pillInput}
                value={email}
                onChange={e=>setEmail(e.target.value)}
                disabled={loading}
                placeholder="ornek@eposta.com"
                required
              />
            </div>
            <div className={styles.fieldGroup}>
              <label htmlFor="password" className={styles.fieldLabel}>Şifre</label>
              <input
                type="password"
                id="password"
                className={styles.pillInput}
                value={password}
                onChange={e=>setPassword(e.target.value)}
                disabled={loading}
                placeholder="Şifreniz"
                required
                minLength={6}
              />
            </div>
            <button type="submit" className={styles.primaryAction} disabled={loading}>
              {loading ? 'Giriş Yapılıyor…' : 'Giriş Yap'}
            </button>
          </form>
          <div className={styles.inlineDivider}><span>veya</span></div>
          <GoogleSignInButton
            text="Google ile Devam Et"
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
          />
          <div className={styles.altAction}>Şifreni mi unuttun? <Link to="/forgot-password">Sıfırla</Link></div>
          <div className={styles.altAction}>Hesabın yok mu? <Link to="/register">Kayıt Ol</Link></div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
